export default {
  'arrow-down': () => import('@icons/arrow/arrow-down.svg'),
  'arrow-down-light': () => import('@icons/arrow/arrow-down-light.svg'),
  'arrow-left': () => import('@icons/arrow/arrow-left.svg'),
  'arrow-left-light': () => import('@icons/arrow/arrow-left-light.svg'),
  'arrow-right': () => import('@icons/arrow/arrow-right.svg'),
  'arrow-right-light': () => import('@icons/arrow/arrow-right-light.svg'),
  'arrow-up': () => import('@icons/arrow/arrow-up.svg'),
  'arrow-up-light': () => import('@icons/arrow/arrow-up-light.svg'),
  'calendar-arrow-left': () => import('@icons/arrow/calendar-arrow-left.svg'),
  'calendar-arrow-right': () => import('@icons/arrow/calendar-arrow-right.svg'),
  'chevron-double-right': () => import('@icons/arrow/chevron-double-right.svg'),
};
